<template>
    <div class="btn-group">
        <button
          v-if="canToggle"
          class="btn btn-sm" :class="[isBound ? 'btn-danger' : 'btn-secondary']"
          @click="toggle"
        >
            <i class="fas" :class="[isBound ? 'fa-unlink' : 'fa-link']"></i>
        </button>
    </div>
</template>

<script>
  export default {
    props: {
      row: Object,
    },

    computed: {
      /**
       * @return {boolean}
       */
      isBound() {
        return this.row.is_bound;
      },

      /**
       * @return {boolean}
       */
      canToggle() {
        return this.row.can.toggle;
      },
    },

    methods: {
      /**
       * @event toggle
       */
      toggle() {
        this.$emit('toggle', {model: this.row.model});
      },
    }
  }
</script>
